import React from 'react'
import { Outlet } from 'react-router-dom'
import ThemeProvider from 'src/components/ThemeProvider/ThemeProvider'
import { ContextProvider } from 'src/context/context'
import 'react-toastify/dist/ReactToastify.min.css';
import SEO from 'src/helpers/seo';

export default function RootLayout() {
  return (
    <ThemeProvider>
      <ContextProvider>
        <SEO title="Challenge | Battle for glory and fortune" description={'Your esports arena, where every move rewards you in digital status and every challenge is rewarding.'} />
        <Outlet />
      </ContextProvider>
    </ThemeProvider>
  )
}
